import React from 'react';
import { Link } from 'react-router-dom';
import blogimage from '../../assets/images/blog_content_img.webp';
import TextContentHeader from './TextContentHeader';
import CallToAction from '../Misc/CallToAction';
import TextContentInner from './TextContentInner';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_2.png';

import { TextContentData } from '../../Data/TextContent';

function TextContent() {
    return (
        <>
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentHeader heading="About Us" />
                    <TextContentInner content={TextContentData} />
                    <div className="text-content-footer bg-black pt-0 pb-0">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Learn more about Dr. Mohammed Audu Foundation
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper d-flex flex-column align-items-end">
                                        <a className="button button-1 mb-3" href="/about">
                                            About us
                                        </a>
                                        <Link className="button button-2" to="/services">
                                            Our services
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Art art={illustration} type="2" />
                </div>

                <div className="single-image ">
                    <img src={blogimage} alt="generic" />
                </div>
            </div>
        </>
    );
}

export default TextContent;

// Duplicate for About page only
export function TextContentAboutPage() {
    const dummyData = [
        { content: 'The Dr. Mohammed Audu Foundation was established to serve as a beacon of hope and access especially for individuals and communities suffering silently from substance use disorders, mental health challenges, and other psychosocial distress, yet lack access to professional support.' },
        { content: 'Founded by Dr. Mohammed Audu, a seasoned mental health professional with over a decade of experience in both theoretical research, hands-on clinical practice and policy formulation, the Foundation represents a deeply personal and professional commitment to change lives not in theory, but in real, practical, and sustainable ways.' }
    ];
    return (
        <>
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentInner content={dummyData} />
                    <Art art={illustration} type="2" />
                </div>
            </div>
        </>
    );
}

// New multi-section layout for About page
export function AboutMultiSection() {
    return (
        <div className="about-multisection">
            <div className="container">
                {/* Our Focus */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Our Focus</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description first-description">
                            Our core programs are designed to close the widening gap in mental health care in Nigeria and Sub-Saharan Africa by providing<br/>
                            • Free and subsidized general counseling and therapy services<br/>
                            • Rehabilitation support for individuals battling substance use<br/>
                            • Community outreach to remote and marginalized populations<br/>
                            • Psychosocial support for trauma, depression, and anxiety<br/>
                            • Capacity building and training for mental health professionals and caregivers<br/>
                            • Public advocacy and awareness campaigns to challenge stigma and misinformation<br/>
                            • Collaborate with institution with similar vision i.e government, private organizations and other non-governmental organizations<br/>
                            • Supporting the Nigeria Correctional services to reduce to the barest minimum the issue of recidivism etc.
                        </p>
                    </div>
                </div>
                {/* Why It Matters */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Why It Matters</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description">
                            Across Nigeria and many parts of Africa, access to mental health care remains a luxury, when it should be a basic right. Far too many individuals suffer in silence not because help doesn't exist, but because it is often inaccessible, unaffordable, or misunderstood. Our Foundation exists to change that narrative.<br/>
                            At DMA we believe that every person regardless of location, income, or background deserves access to compassionate, professional, and culturally competent care. And we are proud to be part of the growing movement that's working to ensure mental health is prioritized as an essential component of holistic well-being.
                        </p>
                    </div>
                </div>
                {/* Our Team */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Our Team</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description">
                            The strength of the Dr. Mohammed Audu Foundation lies in its versatile and interdisciplinary team. From mental health counselors, psychologists, medical practitioners to researchers and social workers, our professionals bring a wealth of experience and a shared passion for healing, empowerment, and advocacy to individuals and communities at large.
                        </p>
                    </div>
                </div>
                {/* Join Us */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Join Us</h3>
                    </div>
                    <div className="col-md-8 d-flex flex-column align-items-start">
                        <p className="paragraph dark-2 mb-3 about-multisection-description">
                            We invite you to collaborate with us, explore our programs, connect with our services, and become part of a vision that's bigger than any one individual. Whether you're seeking help, offering support, partnering or simply learning more you are welcome here.
                        </p>
                        <a href="/get-involved" className="btn btn-main">Volunteer Now</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
